import type { ComponentProps, ReactNode } from 'react'
import { EventCard } from './EventCard'
import { EventAttendanceMenu } from './EventAttendanceMenu'
import type { EventInterestStatus } from '../hooks/useUserEventInterests'

type CardProps = Omit<ComponentProps<typeof EventCard>, 'action' | 'loading' | 'onClick'>

/**
 * An event card with the viewer's RSVP menu in its corner — the shape every
 * event list uses. Omit `onSetStatus` for a card with no RSVP control.
 */
export function SocialEventCard({
  event,
  status,
  onOpen,
  onSetStatus,
  statusLoading,
  menuFooter,
  ...card
}: CardProps & {
  event: NonNullable<CardProps['event']>
  status: EventInterestStatus
  onOpen: () => void
  /** Wrap in the guest guard — guests should see the menu and hit the sign-up wall. */
  onSetStatus?: (status: EventInterestStatus) => void
  /** The viewer's answer isn't known yet (auth or RSVPs still resolving). */
  statusLoading?: boolean
  menuFooter?: ReactNode
}) {
  const action: ReactNode = onSetStatus ? (
    <EventAttendanceMenu
      variant="icon"
      status={status}
      loading={statusLoading}
      onSetStatus={onSetStatus}
      footer={menuFooter}
      onDarkBackground={!!event.imageUrl}
    />
  ) : null
  return (
    <EventCard
      {...card}
      event={event}
      onClick={onOpen}
      action={action}
      declined={!statusLoading && status === 'not_going'}
    />
  )
}
